// removed by extract-text-webpack-plugin
module.exports = {"simpleRacer":"zchUCosEBhw9nWWDGuGra","button":"_2_xGjG5xLi6Aomo6M3bdUv","selected":"_2AySlf5yLFWZ5vVZB7sZ3l","betChipsContainer":"_32vGkNTZnJ0ZH13k0KTRbh","betChips":"_2JCTMPXbE_FdeUfmKsmANs","chipValueOuter":"_2Vmz37sZKYwIL8IKqcydLA","chipValueInner":"_1IPxoB1_p3HU1Qs7IEyWDj"};


//////////////////
// WEBPACK FOOTER
// ./src/ui-modules/simplified/mobile/modules/racing/css/simpleRacer.css
// module id = 1004
// module chunks = 0